import { render, staticRenderFns } from "./Organizacion.vue?vue&type=template&id=6d650bb8"
import script from "./Organizacion.vue?vue&type=script&lang=js"
export * from "./Organizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports